var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniqueVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.99951 7C4.99951 8.06087 5.42094 9.07828 6.17108 9.82843C6.92123 10.5786 7.93865 11 8.99951 11C10.0604 11 11.0778 10.5786 11.8279 9.82843C12.5781 9.07828 12.9995 8.06087 12.9995 7C12.9995 5.93913 12.5781 4.92172 11.8279 4.17157C11.0778 3.42143 10.0604 3 8.99951 3C7.93865 3 6.92123 3.42143 6.17108 4.17157C5.42094 4.92172 4.99951 5.93913 4.99951 7Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3 21V19C3 17.9391 3.42143 16.9217 4.17157 16.1716C4.92172 15.4214 5.93913 15 7 15H11C12.0609 15 13.0783 15.4214 13.8284 16.1716C14.5786 16.9217 15 17.9391 15 19V21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0005 3.13086C16.8609 3.35116 17.6235 3.85156 18.1681 4.55317C18.7127 5.25478 19.0083 6.11769 19.0083 7.00586C19.0083 7.89403 18.7127 8.75694 18.1681 9.45855C17.6235 10.1602 16.8609 10.6606 16.0005 10.8809",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21 21.0004V19.0004C20.9949 18.1175 20.6979 17.2612 20.1553 16.5648C19.6126 15.8684 18.8548 15.3711 18 15.1504",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#2565C8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueVisitors);
export default __webpack_public_path__ + "static/media/unique-visitors.f9cab0e49db9d125323a24ea6dd38ea0.svg";
export { ForwardRef as ReactComponent };